// Promo bar: when a visitor arrived through a discount link (barrier.co/discount/CODE), Shopify leaves the code in
// the discount_code cookie. If that code matches a "Promo code" block in the header section and the promo is
// between its start and end time, the announcement bar says the code is applied. Outside that window, or with
// no end time or an unreadable one, the normal bar stays.
(() => {
  const config = document.getElementById('bw-promo-codes');
  const bar = document.querySelector('.bw-announcement');
  if (!config || !bar) return;

  let promos;
  try {
    promos = JSON.parse(config.textContent);
  } catch {
    return;
  }

  const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
  if (!match) return;
  let code = match[1];
  try {
    code = decodeURIComponent(code);
  } catch {}
  code = code.trim().toUpperCase();

  const now = Date.now();
  const promo = promos.find((p) => {
    if (!p || p.code !== code) return false;
    const ends = Date.parse(p.ends);
    if (!(now < ends)) return false;
    if (p.starts && !(now >= Date.parse(p.starts))) return false;
    return true;
  });
  if (!promo) return;

  const link = document.createElement('a');
  link.href = promo.href || bar.querySelector('a')?.getAttribute('href') || '/';
  const lead = document.createElement('span');
  lead.className = 'bw-announcement-lead';
  lead.textContent = `✓ ${promo.lead || `${code} applied`}`;
  link.append(lead);
  if (promo.pill) {
    const pill = document.createElement('span');
    pill.className = 'bw-announcement-pill';
    pill.textContent = promo.pill;
    link.append(pill);
  }
  bar.replaceChildren(link);
  bar.dataset.promo = code;
})();
